import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ProjectItemStyles = styled.div`
  .projectItem__img {
    width: 100%;
    height: 300px;
    border-radius: 12px;
    overflow: hidden;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .projectItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .projectItem__title {
    font-size: 2.2rem;
  }
  .projectItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  .projectItem__links {
    font-size: 2rem;
    font-style: bold;
    border: 2px solid var(--gray-2);
    text-align: center;
    margin: auto;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
    color: var(--highlight-blue);
    transition: background-color 0.2s ease, color 0.2s ease;
    &:hover {
      background-color: var(--highlight-blue);
      color: var(--dark-bg);
    }
  }
  .projectItem__tech {
    font-size: 1.2rem;
    text-align: center;
    margin: auto;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  @media only screen and (max-width: 768px) {
    .projectItem__img {
      height: 350px;
    }
  }
`;

export default function ProjectItem({
  img = 'ProjectImgPath',
  title = 'Project Name',
  desc = 'Description of App',
  appLink = 'This is link to deployed application',
  githubLink = 'This is link to GitHub repository',
  technologiesUsed = 'This is list of technologies used',
}) {
  return (
    <ProjectItemStyles>
      <Link to="/projects" className="projectItem__img">
        <img src={img} alt={`${title} project screenshot`} />
      </Link>
      <div className="projectItem__info">
        <h3 className="projectItem__title">{title}</h3>
        <p className="projectItem__desc">{desc}</p>
        <a href={appLink} target="_blank" rel="noopener noreferrer">
          <p className="projectItem__links">GO TO APP</p>
        </a>
        <a href={githubLink} target="_blank" rel="noopener noreferrer">
          <p className="projectItem__links">GITHUB REPO</p>
        </a>
        <p className="projectItem__tech">Technologies Used : {technologiesUsed}</p>
      </div>
    </ProjectItemStyles>
  );
}
